/**
 * Link between the Auth context (token owner) and the fetch/SDK layers.
 * The fetch layer asks for a fresh access token on 401 instead of failing
 * the user's action. AuthProvider registers the implementation at mount.
 */
let renewImpl = null;

export function registerTokenRenewer(fn) {
  renewImpl = typeof fn === 'function' ? fn : null;
}

/** Force-refresh the access token. Resolves null when no handler or on failure. */
export async function renewAccessToken() {
  if (!renewImpl) return null;
  try {
    return (await renewImpl()) || null;
  } catch {
    return null;
  }
}
